module.exports = __webpack_public_path__ + "static/media/kotlin.199cbbd8.svg";